import { ActionReducerMap, createFeatureSelector } from '@ngrx/store';

import { coreReducer } from './app.reducer';
import { CoreOriginalSliceState, CoreSliceKey } from './app.state';
import { tagReducer } from './tag.reducer';
import { TagSliceKey, TagSliceState } from './tag.state';
import { taskReducer } from './task.reducer';
import { TaskSliceKey, TaskSliceState } from './task.state';

export const CoreFeatureKey = 'Core';

export interface CoreFeatureState {
	[CoreSliceKey]: CoreOriginalSliceState;
	[TaskSliceKey]: TaskSliceState;
	[TagSliceKey]: TagSliceState;
}

export interface IAppRootState {
	[CoreFeatureKey]: CoreFeatureState;
}

export const featureSelector =
	createFeatureSelector<CoreFeatureState>(CoreFeatureKey);

export const coreReducers: ActionReducerMap<CoreFeatureState> = {
	[CoreSliceKey]: coreReducer,
	[TaskSliceKey]: taskReducer,
	[TagSliceKey]: tagReducer,
};
